import { createContext } from "react";
import type { OrganisationActionsContextType } from "./OrganisationActionsContext.types";

const OrganisationActionsContext = createContext<OrganisationActionsContextType | undefined>(undefined);
OrganisationActionsContext.displayName = "OrganisationActionsContext";

export default OrganisationActionsContext;
